module.exports = __webpack_public_path__ + "img/Inflammation.177d033d.png";